import { Stack, Typography } from "@mui/material";
import { PackingNotesPermission } from "commons/enum/permission";
import { Dayjs } from "dayjs";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { DateRange } from "share-components/atomics/date-range";
import { AddButton } from "share-components/mui-wrap/button/action-button";
import { SearchButton } from "share-components/mui-wrap/button/search-button";
import { XSearchTextField } from "share-components/mui-wrap/text-field/x-search-text-field";
import { PageContentContainer } from "share-components/templates/page/page-content-container";
import { PageFilterContainer } from "share-components/templates/page/page-filter-container";
import { PageHeaderContainer } from "share-components/templates/page/page-header-container";
import { AddPackingNote } from "../add-packing-note/add-packing-note";
import { PackingNoteTable } from "./packing-note-table";
import { ProductGroupSelection } from "share-components/group-selection/product-group-selection/product-group-selection";

export const PackingNoteList = observer(() => {
  const {
    packingNoteManagement: {
      openNew,
      getPackingNotes,
      pagination,
      queryParams: {
        dateRangeFilter: { fromAsDayJs, toAsDayJs, setProp: setDateRangeProps },
        name,
        dealingName,
        number,
        code,
        barcode,
        setProp: setQueryParamProp,
      },
    },
  } = useStores();
  const onSearch = useCallback(async () => {
    pagination.setProp("pageIndex", 0);
    await getPackingNotes();
  }, [getPackingNotes, pagination]);
  const fromDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setDateRangeProps("from", value ? value.toString() : null);
    },
    [setDateRangeProps],
  );

  const toDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setDateRangeProps("to", value ? value.toString() : null);
    },
    [setDateRangeProps],
  );
  return (
    <>
      <PageHeaderContainer direction={"row"} justifyContent={"space-between"}>
        <Header></Header>
      </PageHeaderContainer>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="start"
        gap={4}
      >
        <Stack direction="column" gap={2}>
          <PageFilterContainer>
            <DateRange
              label={"Ngày ĐG"}
              fromDate={fromAsDayJs}
              toDate={toAsDayJs}
              onFromDateChanged={fromDateChangedHandler}
              onToDateChanged={toDateChangedHandler}
            ></DateRange>
            <XSearchTextField
              label="Số phiếu"
              value={number}
              onChange={(e) =>
                setQueryParamProp("number", e.currentTarget.value)
              }
            ></XSearchTextField>
          </PageFilterContainer>
          <PageFilterContainer>
            <ProductGroupSelection
              dealingNameSelected={dealingName}
              nameSelected={name}
              setSelectionProp={setQueryParamProp}
              searchWhenRender={false}
              codeSelected={code}
              visibleFields={["dealingName", "code", "name"]}
            ></ProductGroupSelection>
            <XSearchTextField
              label="Mã barcode"
              value={barcode}
              onChange={(e) =>
                setQueryParamProp("barcode", e.currentTarget.value)
              }
            ></XSearchTextField>
            <SearchButton asyncAction={onSearch}></SearchButton>
          </PageFilterContainer>
        </Stack>
      </Stack>
      <PageContentContainer>
        <PackingNoteTable></PackingNoteTable>
      </PageContentContainer>

      <>{openNew && <AddPackingNote></AddPackingNote>}</>
    </>
  );
});

const Header = observer(() => {
  const {
    packingNoteManagement: { setProp },
  } = useStores();
  return (
    <>
      <Stack>
        <Typography variant="subtitle2">Quản lý phiếu đóng gói</Typography>
      </Stack>
      <Stack>
        <AddButton
          accessPermission={[PackingNotesPermission.Create]}
          onClick={() => {
            setProp("openNew", true);
          }}
        >
          Thêm mới
        </AddButton>
      </Stack>
    </>
  );
});
